import template from './technical-details.jade';
import items from '../../../enums/technical-details';

function splitByCols(items, cols) {
    const itemsCopy = [...items];
    const perCol = Math.ceil(itemsCopy.length / cols);
    const res = [];

    while(itemsCopy.length) {
        res.push(itemsCopy.splice(0, perCol));
    }
    
    return res;
}

export default angular
    .module('cian.addForm.technicalDetails', [])
    .directive('cianAfAboutBuildingTechnicalDetails', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function() {
            this.itemGroups = splitByCols(items, 2);
        }],
        controllerAs: 'technicalDetails',
        template,
    }))
    .name;
